import React from 'react';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import { motion } from 'framer-motion';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { TypeResponse } from './TypeResponse';

export const Question = (props) => {

    const { data, action } = props;
    const classes = useStyles();

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1}}
            transition={{ duration: 1.5 }}
            layoutId={data?.pregunta}
            style={{ width: '100%' }}
        >
            <Grid container display='flex' justifyContent='center'>
                <Grid item xs={ 11 } sm={ 11 } md={ 10 } lg={ 9 } xl={ 6 } alignItems='center'>
                    <h1 className={ classes.title }>{ convertirLetraMayus(data?.pregunta) }</h1>
                    { data?.instrucciones && <p className={ classes.instructionText }>{ convertirLetraMayus(data?.instrucciones) }</p> }

                    <TypeResponse type={ data?.tipo_respuesta?.nombre } action={ (respuesta, pqrs = '') => action({ tipo: data?.tipo_respuesta?.nombre, pregunta: data?.pregunta, respuesta, pqrs }) } options={ data?.tipo_respuesta?.opciones } />
                </Grid>
            </Grid>
        </motion.div>
    )
}

Question.defaultProps = {
    data: {},
    action: () => false,
    animate: false,
    variant: {}
}

const useStyles = makeStyles({
	title: {
		color: '#fff',
		textAlign: 'center',
        marginTop: 50,
        marginBottom: 25,
		letterSpacing: 1,
        fontSize: 'clamp(1.2rem, 4vw, 2.5rem)'
	},
    instructionText: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 'clamp(.9rem, 4vw, 1.4rem)'
    }
});